import { scenePlanSchema } from '../_contract/_@schema/scenePlan.js';
import { scenePlanEffectConstraints } from '../_data/scenePlanSchema.js';
/** Reusable as ResourceType.projectionSchema; no storage envelope or provider-specific fields. */
export function createScenePlanSchema(dialect) {
    if (!dialect || !dialect.targetSchema || typeof dialect.targetSchema !== 'object' || Array.isArray(dialect.targetSchema)) {
        throw new Error('ScenePlan requires an explicit target schema.');
    }
    const kinds = new Set(scenePlanEffectConstraints.map(rule => rule.effectKind));
    for (const extension of dialect.extensions ?? []) {
        const rule = extension.constraint;
        const properties = extension.schema.properties;
        const required = extension.schema.required;
        if (!rule || typeof rule.effectKind !== 'string' || !rule.effectKind.trim() || kinds.has(rule.effectKind)
            || extension.schema.type !== 'object' || extension.schema.additionalProperties !== false
            || !Array.isArray(required) || !required.includes('effectKind')
            || properties?.effectKind?.const !== rule.effectKind
            || !Array.isArray(rule.targetFields) || rule.targetFields.some(field => typeof field !== 'string' || !field.trim())
            || rule.targetFields.some(field => !properties?.[field] || !required.includes(field))
            || new Set(rule.targetFields).size !== rule.targetFields.length
            || (rule.maximumPerSegment !== undefined && (!Number.isInteger(rule.maximumPerSegment) || rule.maximumPerSegment < 1))
            || (rule.stationary !== undefined && typeof rule.stationary !== 'boolean')
            || (rule.beforeCuesOnly !== undefined && typeof rule.beforeCuesOnly !== 'boolean')) {
            throw new Error('Invalid ScenePlan effect extension.');
        }
        kinds.add(rule.effectKind);
    }
    const schema = structuredClone(scenePlanSchema);
    return {
        ...schema,
        $defs: {
            ...schema.$defs,
            target: structuredClone(dialect.targetSchema),
            effect: { oneOf: [
                    ...schema.$defs.effect.oneOf,
                    ...(dialect.extensions ?? []).map(extension => structuredClone(extension.schema)),
                ] },
        },
    };
}
